export default __webpack_public_path__ + "media/transfer_window/transfer_completed-2-ea6b8d5c.mp4";